// src/data/crmEmailCampaign.js
// Campagne email Art Advisors — septembre 2026 (programme CMO).
// Source de vérité des contenus pour copie vers la plateforme d'envoi (Brevo ou autre).
// L'app ne fait PAS l'envoi : elle sert de référentiel + le CRM suit les signaux (crm_activities).

export const CAMPAIGN = {
  code: "AA_SEPT26_EMAIL",
  utm: { source: "email", medium: "email", campaign: "art_advisors_septembre_2026" },
  webinar: {
    title: "Comment transformer un inventaire de collection en dossier client exploitable",
    date: "Mardi 15 septembre 2026",
    time: "12 h 30 (Paris)",
    duration: "45 min (dont 15 min de questions)",
    ctaBefore: "Réserver ma place",
    ctaAfter: "Réserver une démo de 20 minutes",
  },
  offer: {
    name: "Art Advisor Premium",
    price: "199 € / mois",
    scope: "Espace multi-clients, co-gestion jusqu'à 10 clients",
    trial: "Essai accompagné de 30 jours (prospects qualifiés)",
  },
  sender: {
    from: "Vanessa | ARTKIV",
    signature: "Vanessa Quang, fondatrice d'ARTKIV",
    replyTo: "Boîte réellement suivie (jamais no-reply)",
  },
  objectives: [
    { step: "Inscriptions au webinaire", target: "100" },
    { step: "Participants en direct", target: "50" },
    { step: "Démonstrations programmées", target: "20" },
    { step: "Essais accompagnés ouverts", target: "10" },
    { step: "Clients payants (cohorte)", target: "3 à 5" },
  ],
};

// Calendrier maître (phases 0 → 3 + activation)
export const CALENDAR = [
  { phase: "Phase 0 — préparation", rows: [
    { date: "Lun. 31 août", time: "10 h 00", label: "Envoi test interne (liens, UTM, perso, mobile, désinscription)" },
    { date: "Lun. 31 août", time: "15 h 00", label: "Envoi contrôle délivrabilité (petite liste chaude)" },
  ]},
  { phase: "Phase 1 — acquisition vers le webinaire", rows: [
    { date: "Mar. 1 sept.", time: "9 h 30", label: "A1 — Les dossiers dispersés (Camille + Marc)" },
    { date: "Jeu. 3 sept.", time: "10 h 15", label: "A2 — Version persona (Camille / Marc)" },
    { date: "Lun. 7 sept.", time: "9 h 15", label: "A3 — La question client impossible (non-inscrits)" },
    { date: "Jeu. 10 sept.", time: "10 h 00", label: "A4 — Ce que nous montrerons (non-inscrits engagés)" },
    { date: "Lun. 14 sept.", time: "9 h 00", label: "A5 — Demain (tous non-inscrits actifs)" },
  ]},
  { phase: "Phase 2 — rappels inscrits", rows: [
    { date: "À l'inscription", time: "—", label: "W0 — Confirmation" },
    { date: "Ven. 11 sept.", time: "11 h 30", label: "W1 — Préparer votre question" },
    { date: "Lun. 14 sept.", time: "15 h 30", label: "W2 — Rendez-vous demain" },
    { date: "Mar. 15 sept.", time: "10 h 30", label: "W3 — Dans deux heures" },
    { date: "Mar. 15 sept.", time: "12 h 20", label: "W4 — Ouverture de la salle" },
  ]},
  { phase: "Phase 3 — suivi post-webinaire", rows: [
    { date: "Mar. 15 sept.", time: "16 h 30", label: "P1 — Replay + prochaine étape (présents)" },
    { date: "Mar. 15 sept.", time: "16 h 45", label: "N1 — Le replay est disponible (absents)" },
    { date: "Mer. 16 sept.", time: "10 h 00", label: "R1 — Vous avez manqué la session (non-inscrits engagés)" },
    { date: "Jeu. 17 sept.", time: "9 h 30", label: "P2 — Choisissez votre dossier pilote (présents sans démo)" },
    { date: "Ven. 18 sept.", time: "9 h 30", label: "N2 — Les trois idées essentielles (absents sans clic)" },
    { date: "Mar. 22 sept.", time: "10 h 00", label: "P3 — Essai accompagné (présents sans essai)" },
    { date: "Mer. 23 sept.", time: "10 h 00", label: "R2 — Un cas d'usage concret (non-inscrits ayant cliqué)" },
    { date: "Jeu. 24 sept.", time: "10 h 00", label: "N3 — Une démo de 20 minutes (absents engagés)" },
    { date: "Mar. 29 sept.", time: "9 h 30", label: "P4 — Dernière cohorte (présents sans conversion)" },
    { date: "Mer. 30 sept.", time: "9 h 30", label: "N4/R3 — Clôture septembre" },
  ]},
  { phase: "Activation de l'essai (déclenchée par trial_started)", rows: [
    { date: "T0 — ouverture", time: "—", label: "Bienvenue — créer le premier dossier client" },
    { date: "T1 — J+1", time: "—", label: "Ne ressaisissez pas ce que vous possédez déjà (import)" },
    { date: "T2 — J+3", time: "—", label: "Votre premier dossier doit déjà produire quelque chose" },
    { date: "T3 — J+7", time: "—", label: "Transformez les données en livrable (rapport)" },
    { date: "T4 — J+14", time: "—", label: "Testez la co-gestion avec votre client" },
    { date: "T5 — J+21", time: "—", label: "Votre dossier pilote est-il plus exploitable ?" },
    { date: "T6 — J+27", time: "—", label: "Votre essai se termine dans trois jours" },
    { date: "T7 — J+30", time: "—", label: "Essai terminé : que faire du dossier ? (non converti)" },
  ]},
];

// Contenus complets, regroupés. body = tableau de paragraphes.
export const EMAIL_GROUPS = [
  {
    id: "acquisition",
    title: "1 — Acquisition vers le webinaire",
    emails: [
      {
        id: "A1", when: "Mar. 1 sept. · 9 h 30", segment: "Camille + Marc",
        objectA: "Combien de dossiers clients gérez-vous encore à la main ?",
        objectB: "Votre expertise mérite mieux qu'un dossier dispersé",
        preheader: "Inventaires, certificats, valeurs et échanges clients enfin réunis dans un même espace.",
        utmContent: "aa_acq_e1_dossiers_disperses", ctaPrimary: "Réserver ma place",
        crmAction: "Après clic : lead_score +10, next_action_type = proposer_demo_si_reponse",
        body: [
          "Bonjour {{first_name}},",
          "Un dossier de collection commence rarement dans un seul outil.",
          "Il se construit entre des tableurs, des PDF, des photos, des certificats, des messages et parfois la mémoire de plusieurs personnes. Le problème apparaît le jour où le client demande une réponse immédiate : où se trouve l'œuvre, quelle est sa dernière valeur, quels documents manquent, que faut-il préparer pour l'assurance ou la transmission ?",
          "ARTKIV réunit ces informations dans un espace privé, structuré et pilotable par l'Art Advisor.",
          "Le mardi 15 septembre à 12 h 30, je présenterai concrètement comment transformer un inventaire existant en dossier client exploitable, sans recommencer tout le travail déjà réalisé.",
        ],
      },
      {
        id: "A2-C", when: "Jeu. 3 sept. · 10 h 15", segment: "Camille (indépendantes)",
        objectA: "Dix clients, dix collections, une seule vue",
        objectB: "Le tableau de bord que vos dossiers clients attendent",
        preheader: "Suivez les œuvres, documents, valeurs et prochaines actions sans multiplier les fichiers.",
        utmContent: "aa_acq_e2_camille_multiclients", ctaPrimary: "Découvrir le webinaire",
        body: [
          "Bonjour {{first_name}},",
          "Lorsque l'on accompagne plusieurs collectionneurs, le temps ne se perd pas seulement dans le conseil. Il disparaît dans la recherche d'informations : retrouver une facture, vérifier une estimation, préparer un rapport, identifier un document manquant ou reconstituer l'historique d'une œuvre.",
          "ARTKIV a été conçu pour vous permettre de piloter plusieurs collections depuis une même vue, tout en maintenant un espace strictement séparé et privé pour chaque client.",
          "Pendant le webinaire du 15 septembre, nous montrerons notamment : la gestion multi-clients ; l'import d'un inventaire existant ; les rapports professionnels co-marqués ; le partage contrôlé avec le collectionneur et ses conseils.",
        ],
      },
      {
        id: "A2-M", when: "Jeu. 3 sept. · 10 h 15", segment: "Marc (galerie / structure)",
        objectA: "Et si le conseil continuait après l'acquisition ?",
        objectB: "Donner une forme durable au service de la galerie",
        preheader: "Un espace client qui prolonge la relation après la vente et valorise votre accompagnement.",
        utmContent: "aa_acq_e2_marc_service_galerie", ctaPrimary: "Réserver ma place",
        body: [
          "Bonjour {{first_name}},",
          "La relation avec un collectionneur ne s'arrête pas au moment où l'œuvre quitte la galerie.",
          "Viennent ensuite les questions de documentation, d'assurance, de localisation, de valorisation, de prêt, de revente ou de transmission. Ces demandes sont souvent traitées au cas par cas, alors qu'elles constituent une part essentielle de la valeur du conseil.",
          "ARTKIV permet à une galerie ou à un Art Advisor de prolonger ce service dans un espace client structuré, privé et co-marqué.",
          "Le 15 septembre à 12 h 30, nous présenterons ce parcours en direct, depuis l'import d'un inventaire jusqu'au rapport professionnel partageable.",
        ],
      },
      {
        id: "A3", when: "Lun. 7 sept. · 9 h 15", segment: "Non-inscrits",
        objectA: "Votre client vous pose cette question demain",
        objectB: "Pouvez-vous répondre en dix minutes ?",
        preheader: "Certificats, localisation, valeur, assurance, succession : le dossier doit répondre sans tout rechercher.",
        utmContent: "aa_acq_e3_question_client", ctaPrimary: "Voir le programme et réserver",
        body: [
          "Bonjour {{first_name}},",
          "Imaginez qu'un client vous appelle demain avec quatre questions : 1. Où sont les certificats des œuvres principales ? 2. Quelle valeur peut-il communiquer à son assureur ? 3. Quelles pièces sont insuffisamment documentées ? 4. Quel dossier transmettre à son notaire ou à ses héritiers ?",
          "La valeur du conseil ne dépend pas seulement de la justesse de la réponse. Elle dépend aussi de la capacité à la produire vite, à l'expliquer et à la documenter.",
          "C'est précisément le sujet du webinaire ARTKIV du mardi 15 septembre.",
        ],
      },
      {
        id: "A4", when: "Jeu. 10 sept. · 10 h 00", segment: "Non-inscrits ayant ouvert/cliqué",
        objectA: "Ce que nous montrerons mardi prochain",
        objectB: "De l'inventaire au dossier client : démonstration en direct",
        preheader: "Une démonstration concrète, sans présentation abstraite ni promesse de logiciel miracle.",
        utmContent: "aa_acq_e4_programme_webinaire", ctaPrimary: "Réserver ma place pour le 15 septembre",
        body: [
          "Bonjour {{first_name}},",
          "Le webinaire du 15 septembre sera volontairement concret.",
          "En 30 minutes de démonstration, nous partirons d'un dossier de collection dispersé pour montrer comment : importer les informations existantes ; organiser les œuvres, documents, valeurs et emplacements ; suivre plusieurs clients depuis un même tableau de bord ; produire un rapport professionnel au nom de l'Art Advisor ; ouvrir les bons accès au collectionneur, à un expert ou à un conseil patrimonial.",
          "Nous garderons ensuite 15 minutes pour les questions des participants.",
        ],
      },
      {
        id: "A5", when: "Lun. 14 sept. · 9 h 00", segment: "Non-inscrits actifs",
        objectA: "Demain à 12 h 30 : ARTKIV pour les Art Advisors",
        objectB: "Dernière invitation pour la démonstration de demain",
        preheader: "45 minutes pour voir comment transformer un inventaire en dossier client exploitable.",
        utmContent: "aa_acq_e5_derniere_invitation", ctaPrimary: "Réserver ma place",
        body: [
          "Bonjour {{first_name}},",
          "Demain à 12 h 30, je présenterai ARTKIV aux Art Advisors qui souhaitent mieux structurer le suivi des collections de leurs clients.",
          "Nous verrons comment passer d'informations dispersées à un dossier professionnel utilisable pour le conseil, l'assurance, la valorisation ou la transmission.",
          "L'inscription reste ouverte jusqu'au début de la session.",
        ],
      },
    ],
  },
  {
    id: "webinaire",
    title: "2 — Rappels webinaire (inscrits)",
    emails: [
      {
        id: "W0", when: "Immédiatement après inscription", segment: "Inscrits",
        objectA: "Votre inscription est confirmée — 15 septembre à 12 h 30",
        preheader: "Ajoutez le rendez-vous à votre calendrier et transmettez-nous votre question.",
        ctaPrimary: "Ajouter à mon calendrier", ctaSecondary: "Poser ma question",
        crmAction: "webinar_status = registered, stage = qualifie, lead_score +10",
        body: [
          "Bonjour {{first_name}},",
          "Votre inscription au webinaire ARTKIV est confirmée.",
          "Comment transformer un inventaire de collection en dossier client exploitable — Mardi 15 septembre 2026, 12 h 30 (Paris), durée 45 minutes.",
          "Vous recevrez le lien d'accès avant la session. Vous pouvez dès maintenant ajouter le rendez-vous à votre calendrier et nous transmettre la question que vous aimeriez voir traitée pendant la démonstration.",
        ],
      },
      {
        id: "W1", when: "Ven. 11 sept. · 11 h 30", segment: "Inscrits",
        objectA: "Quelle question souhaitez-vous poser mardi ?",
        preheader: "Import, multi-clients, rapports, valorisation ou partage : dites-nous ce que vous voulez voir.",
        ctaPrimary: "Envoyer ma question",
        body: [
          "Bonjour {{first_name}},",
          "Le webinaire ARTKIV aura lieu mardi prochain à 12 h 30.",
          "Pour que la démonstration réponde aux situations réelles des Art Advisors, vous pouvez nous indiquer le sujet qui vous intéresse le plus : import d'inventaire, gestion multi-clients, rapports, valorisation, droits d'accès ou préparation d'un dossier patrimonial.",
        ],
      },
      {
        id: "W2", when: "Lun. 14 sept. · 15 h 30", segment: "Inscrits",
        objectA: "Rendez-vous demain à 12 h 30",
        preheader: "Votre lien d'accès au webinaire ARTKIV.",
        ctaPrimary: "Accéder au webinaire",
        body: [
          "Bonjour {{first_name}},",
          "Nous nous retrouvons demain à 12 h 30 pour la démonstration ARTKIV destinée aux Art Advisors.",
          "Voici votre lien personnel d'accès. La salle ouvrira dix minutes avant le début. Le replay sera envoyé aux personnes inscrites.",
        ],
      },
      {
        id: "W3", when: "Mar. 15 sept. · 10 h 30", segment: "Inscrits",
        objectA: "Nous commençons dans deux heures",
        preheader: "Le lien pour rejoindre la démonstration ARTKIV à 12 h 30.",
        ctaPrimary: "Rejoindre la session à 12 h 30",
        body: [
          "Bonjour {{first_name}},",
          "La démonstration ARTKIV commence aujourd'hui à 12 h 30. Gardez ce lien à portée de main.",
        ],
      },
      {
        id: "W4", when: "Mar. 15 sept. · 12 h 20", segment: "Inscrits",
        objectA: "La salle est ouverte",
        preheader: "La démonstration commence dans dix minutes.",
        ctaPrimary: "Entrer dans le webinaire",
        body: ["Bonjour {{first_name}},", "La salle est ouverte. Nous commençons dans dix minutes."],
      },
    ],
  },
  {
    id: "post",
    title: "3 — Suivi post-webinaire",
    emails: [
      {
        id: "P1", when: "Mar. 15 sept. · 16 h 30", segment: "Présents",
        objectA: "Le replay et la prochaine étape",
        objectB: "Quel dossier client choisir pour commencer ?",
        preheader: "Revoir la démonstration et réserver un diagnostic de 20 minutes.",
        utmContent: "aa_post_attendee_replay", ctaPrimary: "Réserver ma démo de 20 minutes", ctaSecondary: "Voir le replay",
        crmAction: "webinar_status = attended, lead_score +15 ; action sous 48 h si clic sans réservation",
        body: [
          "Bonjour {{first_name}},",
          "Merci d'avoir participé à la présentation ARTKIV. Voici le replay ainsi qu'un résumé des étapes montrées pendant la session.",
          "La meilleure façon d'évaluer ARTKIV n'est pas de tester toutes les fonctions. Elle consiste à choisir un seul dossier client représentatif : un inventaire existant, quelques documents, une problématique réelle et une prochaine échéance.",
          "Pendant une démo individuelle de 20 minutes, nous pouvons identifier ce premier dossier pilote et vérifier la méthode d'import la plus adaptée.",
        ],
      },
      {
        id: "N1", when: "Mar. 15 sept. · 16 h 45", segment: "Absents",
        objectA: "Vous n'avez pas pu venir : voici le replay",
        preheader: "La démonstration ARTKIV reste accessible pendant quinze jours.",
        utmContent: "aa_post_noshow_replay", ctaPrimary: "Voir le replay",
        crmAction: "webinar_status = absent",
        body: [
          "Bonjour {{first_name}},",
          "Vous n'avez pas pu participer au webinaire de ce midi. Le replay est maintenant disponible.",
          "Vous y verrez comment passer d'un inventaire dispersé à un espace multi-clients, puis produire un dossier professionnel partageable. Le replay restera accessible pendant quinze jours.",
        ],
      },
      {
        id: "R1", when: "Mer. 16 sept. · 10 h 00", segment: "Non-inscrits engagés",
        objectA: "La démonstration ARTKIV est disponible en replay",
        preheader: "Un aperçu concret du tableau de bord multi-clients et des rapports Art Advisor.",
        ctaPrimary: "Accéder au replay",
        body: [
          "Bonjour {{first_name}},",
          "La démonstration ARTKIV destinée aux Art Advisors a eu lieu hier. Nous avons décidé de rendre le replay accessible pendant quinze jours aux professionnels qui avaient manifesté leur intérêt.",
          "Vous pourrez notamment voir le parcours d'import, la gestion multi-clients et la génération d'un rapport professionnel.",
        ],
      },
      {
        id: "P2", when: "Jeu. 17 sept. · 9 h 30", segment: "Présents sans démo",
        objectA: "Quel serait votre premier dossier pilote ?",
        preheader: "Un seul client suffit pour vérifier si ARTKIV améliore réellement votre manière de travailler.",
        utmContent: "aa_post_demo", ctaPrimary: "Choisir mon dossier pilote",
        body: [
          "Bonjour {{first_name}},",
          "Après le webinaire, une question revient souvent : faut-il préparer tous ses dossiers avant de commencer ? Non.",
          "Le meilleur test consiste à sélectionner un client et un besoin concret : reprendre un inventaire existant ; préparer un rapport d'assurance ; mettre à jour une valorisation ; documenter une succession ; organiser le partage avec un Family Office ou un notaire.",
          "Nous pouvons identifier ce dossier avec vous pendant une démonstration de 20 minutes.",
        ],
      },
      {
        id: "N2", when: "Ven. 18 sept. · 9 h 30", segment: "Absents sans clic",
        objectA: "Les trois idées essentielles du webinaire",
        preheader: "Ce qu'ARTKIV change concrètement pour un Art Advisor.",
        ctaPrimary: "Voir la démonstration",
        body: [
          "Bonjour {{first_name}},",
          "Voici les trois idées essentielles de la démonstration ARTKIV : 1. un Art Advisor doit pouvoir piloter plusieurs collections sans mélanger les données de ses clients ; 2. un inventaire prend de la valeur professionnelle lorsqu'il devient un dossier documenté, partageable et actualisable ; 3. le client doit voir la valeur du conseil dans les livrables, les décisions et la continuité du suivi.",
          "Le replay reste disponible.",
        ],
      },
      {
        id: "P3", when: "Mar. 22 sept. · 10 h 00", segment: "Présents sans essai",
        objectA: "Ouvrir un essai avec un vrai dossier, pas une base vide",
        preheader: "Nous vous accompagnons pour choisir le premier client et la bonne méthode d'import.",
        ctaPrimary: "Démarrer avec un dossier client",
        body: [
          "Bonjour {{first_name}},",
          "Un essai vide ne permet pas d'évaluer un outil métier.",
          "Pour les Art Advisors qualifiés, ARTKIV propose un essai accompagné de 30 jours construit autour d'un dossier réel. L'objectif est de vérifier trois résultats : les informations sont mieux structurées ; le rapport produit est réellement présentable au client ; le suivi demande moins de manipulations dispersées.",
          "L'abonnement Art Advisor Premium est ensuite proposé à 199 € par mois pour la co-gestion de 10 clients.",
        ],
      },
      {
        id: "R2", when: "Mer. 23 sept. · 10 h 00", segment: "Non-inscrits ayant cliqué",
        objectA: "Un cas d'usage : préparer le dossier d'assurance d'un client",
        preheader: "Localisation, valeurs, documents et rapport réunis sans reconstruire le dossier à chaque demande.",
        ctaPrimary: "Réserver une démonstration",
        body: [
          "Bonjour {{first_name}},",
          "Prenons un cas simple : un collectionneur doit actualiser son dossier d'assurance.",
          "Sans espace structuré, il faut retrouver les localisations, sélectionner les valeurs pertinentes, contrôler les visuels, rattacher les documents et reconstituer un rapport.",
          "Dans ARTKIV, ces informations sont maintenues dans le dossier de la collection et peuvent être reprises dans un rapport professionnel co-marqué. Une démonstration de 20 minutes suffit pour vérifier ce parcours avec votre propre manière de travailler.",
        ],
      },
      {
        id: "N3", when: "Jeu. 24 sept. · 10 h 00", segment: "Absents engagés",
        objectA: "Préférez-vous une démonstration de 20 minutes ?",
        preheader: "Nous pouvons aller directement au cas d'usage qui correspond à vos clients.",
        ctaPrimary: "Choisir mon créneau",
        body: [
          "Bonjour {{first_name}},",
          "Le format webinaire n'est pas toujours le plus pratique.",
          "Nous pouvons vous présenter ARTKIV en 20 minutes, à partir du sujet qui compte le plus dans votre activité : gestion multi-clients, import, rapports, valorisation, assurance ou transmission.",
        ],
      },
      {
        id: "P4", when: "Mar. 29 sept. · 9 h 30", segment: "Présents sans conversion",
        objectA: "Dernière cohorte d'essai accompagnée de septembre",
        preheader: "Nous clôturons cette semaine les démarrages accompagnés issus du webinaire.",
        ctaPrimary: "Réserver ma démo avant la clôture",
        body: [
          "Bonjour {{first_name}},",
          "Nous clôturons cette semaine la cohorte de septembre des Art Advisors accompagnés sur leur premier dossier ARTKIV.",
          "L'accompagnement comprend le choix du dossier pilote, l'onboarding et la définition de la méthode d'import. Il ne vous engage pas à migrer immédiatement l'ensemble de vos clients.",
        ],
      },
      {
        id: "N4/R3", when: "Mer. 30 sept. · 9 h 30", segment: "Absents / non-inscrits engagés",
        objectA: "Clôture de la campagne Art Advisors de septembre",
        preheader: "Dernier message concernant la démonstration et l'essai accompagné.",
        ctaPrimary: "Voir le replay ou réserver une démo",
        body: [
          "Bonjour {{first_name}},",
          "Ceci est le dernier email de la campagne ARTKIV destinée aux Art Advisors en septembre.",
          "Le replay reste disponible aujourd'hui et nous conservons quelques créneaux pour une démonstration individuelle. Ensuite, nous arrêterons cette séquence et reprendrons uniquement les échanges demandés directement.",
        ],
      },
    ],
  },
  {
    id: "activation",
    title: "4 — Activation de l'essai (30 j, déclenchée par trial_started)",
    emails: [
      {
        id: "T0", when: "Ouverture de l'essai", segment: "Essai en cours",
        objectA: "Bienvenue dans votre espace Art Advisor ARTKIV",
        utmContent: "aa_trial_activation", ctaPrimary: "Créer mon premier dossier client",
        crmAction: "Objectif : premier client créé sous 24 h",
        body: [
          "Bonjour {{first_name}},",
          "Votre espace Art Advisor est ouvert pour 30 jours.",
          "Ne commencez pas par tout importer. Choisissez d'abord un seul dossier client suffisamment représentatif de votre activité. Votre première étape consiste à créer ce client et à préciser le résultat attendu : inventaire, assurance, valorisation, transmission ou rapport de suivi.",
        ],
      },
      {
        id: "T1", when: "J+1", segment: "Essai en cours",
        objectA: "Ne ressaisissez pas ce que vous possédez déjà",
        ctaPrimary: "Choisir ma méthode d'import",
        body: [
          "Bonjour {{first_name}},",
          "Votre inventaire existe probablement déjà sous une forme ou une autre : tableur, PDF, export de base, dossier de photos ou documents séparés.",
          "Depuis votre onboarding, indiquez le format disponible. ARTKIV vous orientera vers l'import Express, Premium ou Conciergerie selon le volume et l'état du dossier.",
        ],
      },
      {
        id: "T2", when: "J+3", segment: "Essai en cours",
        objectA: "Votre premier dossier doit déjà produire quelque chose",
        ctaPrimary: "Continuer mon dossier pilote",
        crmAction: "Si aucune œuvre ajoutée → action humaine verifier_activation",
        body: [
          "Bonjour {{first_name}},",
          "À ce stade, votre espace doit contenir au minimum : un client ; une collection ; une œuvre ; un document rattaché à cette œuvre.",
          "Ce petit noyau suffit pour tester la logique du dossier et éviter un essai purement théorique.",
        ],
      },
      {
        id: "T3", when: "J+7", segment: "Essai en cours",
        objectA: "Transformez les données en livrable client",
        ctaPrimary: "Générer mon premier rapport",
        crmAction: "Objectif J+7 : ≥ 3 œuvres, 1 document, 1 rapport/action pro",
        body: [
          "Bonjour {{first_name}},",
          "Une base de données n'a de valeur pour l'Art Advisor que lorsqu'elle produit un résultat visible pour le client.",
          "Générez maintenant un premier rapport : inventaire, valorisation, assurance ou succession. Ajoutez votre identité professionnelle et vérifiez si le document correspond au niveau de présentation que vous souhaitez remettre à votre client.",
        ],
      },
      {
        id: "T4", when: "J+14", segment: "Essai en cours",
        objectA: "Testez la co-gestion avec votre client",
        ctaPrimary: "Inviter mon client ou un collaborateur",
        body: [
          "Bonjour {{first_name}},",
          "ARTKIV ne remplace pas la relation avec votre client. Il lui donne un cadre.",
          "Invitez une personne de confiance sur le dossier pilote et définissez précisément ce qu'elle peut voir ou modifier. Vous pourrez révoquer l'accès à tout moment.",
        ],
      },
      {
        id: "T5", when: "J+21", segment: "Essai en cours",
        objectA: "Votre dossier pilote est-il devenu plus exploitable ?",
        ctaPrimary: "Faire le point en 20 minutes",
        body: [
          "Bonjour {{first_name}},",
          "Après trois semaines, trois questions permettent d'évaluer l'essai : 1. retrouvez-vous plus vite l'information ? 2. le dossier produit-il un meilleur livrable pour le client ? 3. pouvez-vous reproduire cette méthode sur vos autres clients ?",
          "Nous pouvons faire le point ensemble et identifier les derniers blocages.",
        ],
      },
      {
        id: "T6", when: "J+27", segment: "Essai en cours",
        objectA: "Votre essai ARTKIV se termine dans trois jours",
        ctaPrimary: "Conserver mon espace Art Advisor",
        body: [
          "Bonjour {{first_name}},",
          "Votre essai accompagné se termine dans trois jours.",
          "L'abonnement Art Advisor Premium est proposé à 199 € par mois et comprend la co-gestion de 10 clients. Vos données et votre dossier pilote restent dans votre espace lors du passage à l'abonnement.",
          "Pour toute question sur l'import ou le périmètre du compte, répondez directement à cet email.",
        ],
      },
      {
        id: "T7", when: "J+30 (non converti)", segment: "Essai terminé",
        objectA: "Votre essai est terminé : que souhaitez-vous faire du dossier ?",
        ctaPrimary: "Choisir la suite",
        crmAction: "Aucune relance auto supplémentaire sans nouveau signal d'intérêt",
        body: [
          "Bonjour {{first_name}},",
          "Votre essai ARTKIV est arrivé à son terme.",
          "Vous pouvez activer l'abonnement Art Advisor Premium, demander un échange sur le périmètre de votre besoin ou clôturer le dossier pilote.",
        ],
      },
    ],
  },
];

// Règles d'automatisation (déclencheurs → action), pour affichage + implémentation future.
export const AUTOMATION_RULES = [
  { event: "Clic vers le webinaire", action: "lead_score +10" },
  { event: "Inscription au webinaire", action: "Sortie acquisition → séquence inscrits, webinar_status=registered, stage=qualifie" },
  { event: "Présence au webinaire", action: "Séquence présents, lead_score +15, webinar_status=attended" },
  { event: "Absence au webinaire", action: "Séquence absents, webinar_status=absent" },
  { event: "Réservation d'une démo", action: "Sortie séquences marketing, stage=demo, lead_score +20" },
  { event: "Démo réalisée", action: "lead_score +25, prochaine action sous 24 h" },
  { event: "Essai démarré", action: "Séquence activation, stage=essai, lead_score +30" },
  { event: "Abonnement activé", action: "Sortie séquences, stage=client" },
  { event: "Réponse à un email", action: "Pause automatisation + tâche humaine « À traiter aujourd'hui »" },
  { event: "Désinscription", action: "unsubscribed_at, suspension définitive des emails" },
  { event: "Bounce permanent", action: "email_status=bounced, aucune nouvelle tentative" },
];
